<template>
  <v-container fluid>
    <v-dialog
        v-model="editDialog"
        max-width="80%"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Детальная информация</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                  cols="12"
                  sm="6"
                  md="4"
              >
                <v-text-field
                    v-model="editedItem.fullName"
                    label="ФИО"
                ></v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="4"
              >
                <v-text-field
                    v-model="editedItem.carBrandName"
                    label="Бренд авто"
                ></v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="4"
              >
                <v-text-field
                    v-model="editedItem.carModelName"
                    label="Модель авто"
                ></v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="4"
              >
                <v-text-field
                    v-model="editedItem.carStateNumber"
                    label="Гос. номер авто"
                ></v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="4"
              >
                <v-text-field
                    v-model="editedItem.vinCode"
                    label="VIN код авто"
                ></v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="4"
              >
                <v-text-field
                    type="number"
                    v-model="editedItem.mileage"
                    label="Пробег"
                ></v-text-field>
              </v-col>

              <v-col
                  cols="12"
                  sm="6"
                  md="4"
              >
                <v-text-field
                    v-model="editedItem.checkInTime"
                    label="Дата заезда"
                ></v-text-field>
              </v-col>
            </v-row>
            <div v-if="editedItem.jobSet.length > 0">
              <div class="mt-4">
                Список выполненных работ
              </div>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-left">
                      Наименование
                    </th>
                    <th class="text-left">
                      Кол-во
                    </th>
                    <th class="text-left">
                      Цена
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      v-for="item in editedItem.jobSet"
                      :key="item.name"
                  >
                    <td>{{ item.name }}</td>
                    <td>{{ item.amount }}</td>
                    <td>{{ item.price }}</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
            <div v-if="editedItem.shareParts.length > 0">
              <div class="mt-4">
                Запчасти и расходные материалы
              </div>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-left">
                      Наименование
                    </th>
                    <th class="text-left">
                      Кол-во
                    </th>
                    <th class="text-left">
                      Цена
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      v-for="item in editedItem.shareParts"
                      :key="item.name"
                  >
                    <td>{{ item.name }}</td>
                    <td>{{ item.amount }}</td>
                    <td>{{ item.price }}</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="close"
          >
            Закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Панель фильтров -->
    <v-card class="mb-4">
      <v-card-title>
        Заказ наряд
      </v-card-title>
    </v-card>
    <v-card class="mt-6">
      <v-data-table
          :headers="headers"
          :items="data"
          class="elevation-1"
          :footer-props="{
            'items-per-page-text': 'Строк на странице:',
            'items-per-page-options': [5, 10, 20, 50]
          }"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-row>
              <v-col>
                <v-btn
                    @click="addPurchase"
                    depressed
                    color="primary"
                >
                  <v-icon
                      left
                      dark
                  >
                    mdi-plus
                  </v-icon>
                  Создать заказ наряд
                </v-btn>
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
              class="mr-2"
              @click="editItem(item)"
          >
            mdi-text-box-outline
          </v-icon>
          <v-icon
              class="mr-2"
              @click="goToDetail(item)"
          >
            mdi-printer
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import { format } from 'date-fns'

export default {
  name: 'PartnerPurchaseOrder',
  data() {
    return {
      selects: ['Да', 'Нет'],
      editedItem: {
        jobSet: [],
        shareParts: []
      },
      editDialog: false,
      searchText: '',
      filters: {
        brandId: null,
      },
      data: [],
      spareBrands: [],
      size: 10,
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Пользователь', value: 'fullName' },
        { text: 'Бренд авто', value: 'carBrandName' },
        { text: 'Модель авто', value: 'carModelName' },
        { text: 'Гос. номер', value: 'carStateNumber' },
        { text: 'VIN код', value: 'vinCode' },
        { text: 'Дата заезда', value: 'checkInTime' },
        { text: 'Пробег', value: 'mileage' },
        { text: 'Общая сумма работ', value: 'totalSumJob' },
        { text: 'Общая сумма запчастей', value: 'totalSumParts' },
        { text: 'Действия', value: 'actions' },
      ],
      totalElements: 0,
      options: {}
    }
  },
  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    close () {
      this.editDialog = false
      this.editedItem = {
        jobSet: [],
        shareParts: []
      }
    },
    editItem (item) {
      console.log(item)
      this.editedItem = Object.assign({}, item)
      this.editDialog = true
    },
    goToDetail (item) {
      this.$router.push({ name: 'PurchaseDetail', params: { id: item.id } })
    },
    addPurchase () {
      this.$router.push('/partner/purchase/add')
    },
    async getData () {
      try {
        const resp = await this.$store.dispatch('partnerPurchaseOrder/getPartnerPurchaseOrders')
        this.data = resp.map((item) => {
          item.carBrandName = item.carBrand.name
          item.carModelName = item.carModel.name
          item.checkInTime = format(new Date(item.checkInTime), 'dd.MM.yyyy HH:mm')
          return item
        })
        this.totalElements = resp.totalElements
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
<style scoped>

</style>